import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import SectionHeading from '@/components/base/SectionHeading';

export default function HotRanking() {
  const ranking = [...comics].sort((a, b) => Number(b.rating) - Number(a.rating)).slice(0, 8);
  const picks = comics.filter((c) => c.isRecommended).slice(0, 4);

  return (
    <section className="bg-background-100 py-10 md:py-14" aria-label="热门榜单与编辑精选">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5 lg:gap-10">
          <div className="lg:col-span-3">
            <SectionHeading title="热门榜单" subtitle="全站人气与口碑 TOP8，跟着榜单追更不踩雷" moreTo="/category/all?sort=hot" moreLabel="完整榜单" />
            <ol className="flex flex-col gap-2.5">
              {ranking.map((comic, index) => (
                <li key={comic.id}>
                  <Link
                    to={`/comic/${comic.id}`}
                    className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-2.5 transition-colors hover:border-primary-300 hover:bg-primary-50 md:gap-4"
                  >
                    <span
                      className={`rank-badge flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-base font-bold md:h-10 md:w-10 md:text-lg ${
                        index === 0
                          ? 'bg-accent-500 text-background-50'
                          : index < 3
                            ? 'bg-primary-500 text-background-50'
                            : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {index + 1}
                    </span>
                    <img
                      src={comic.cover}
                      alt={`${comic.title}漫画封面`}
                      title={`${comic.title}漫画免费阅读`}
                      className="h-16 w-12 shrink-0 rounded-md object-cover object-top md:h-20 md:w-14"
                    />
                    <div className="min-w-0 flex-1">
                      <h3 className="truncate text-sm font-bold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                        {comic.title}
                      </h3>
                      <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                        <span className="flex items-center gap-1 whitespace-nowrap">
                          <i className="ri-star-fill h-3.5 w-3.5 text-secondary-500" aria-hidden="true"></i>
                          {comic.rating}分
                        </span>
                        <span className="flex items-center gap-1 whitespace-nowrap">
                          <i className="ri-eye-line h-3.5 w-3.5" aria-hidden="true"></i>
                          {comic.views}
                        </span>
                        <span className="truncate">{comic.status === '连载中' ? comic.latestChapter : '已完结'}</span>
                      </p>
                    </div>
                    <i className="ri-arrow-right-s-line h-5 w-5 shrink-0 text-foreground-400 transition-all group-hover:translate-x-0.5 group-hover:text-primary-500" aria-hidden="true"></i>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-2">
            <SectionHeading title="编辑精选" subtitle="编辑部每周人工严选，错过一部都可惜" moreTo="/category/all?sort=rating" moreLabel="更多精选" />
            <div className="flex flex-col gap-3">
              {picks.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-2.5 transition-colors hover:border-primary-300 hover:bg-primary-50 md:gap-4"
                >
                  <img
                    src={comic.cover}
                    alt={`${comic.title}漫画封面`}
                    title={`${comic.title}漫画编辑推荐`}
                    className="h-24 w-16 shrink-0 rounded-md object-cover object-top md:h-28 md:w-20"
                  />
                  <div className="min-w-0 flex-1">
                    <span className="inline-flex items-center gap-1 rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] font-medium text-secondary-900">
                      <i className="ri-award-fill h-3 w-3" aria-hidden="true"></i>
                      编辑推荐
                    </span>
                    <h3 className="mt-1.5 truncate text-sm font-bold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                      {comic.title}
                    </h3>
                    <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-600">{comic.description}</p>
                    <p className="mt-1.5 flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-user-line h-3.5 w-3.5" aria-hidden="true"></i>
                      {comic.author}
                      <span className="ml-auto flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-star-fill h-3.5 w-3.5 text-secondary-500" aria-hidden="true"></i>
                        {comic.rating}
                      </span>
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}